import { z } from 'zod';
import { ForumCategory, ForumEventRsvpSummary, ForumPoll, ForumPost, ForumPostTranslation, ForumRevision, ForumThread, ForumThreadDetail, ForumThreadKind, ForumThreadTranslation, } from './forum.js';
export const ForumCategoryResponse = z.object({ category: ForumCategory });
export const ForumCategoryListResponse = z.object({
    categories: z.array(ForumCategory),
});
export const ForumThreadResponse = z.object({ thread: ForumThread });
export const ForumThreadDetailResponse = z.object({ thread: ForumThreadDetail });
export const ForumThreadListResponse = z.object({
    threads: z.array(ForumThread),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
export const ForumPostResponse = z.object({ post: ForumPost });
export const ForumTranslationsResponse = z.object({
    threads: z.array(ForumThreadTranslation),
    posts: z.array(ForumPostTranslation),
});
export const ForumSubscriptionResponse = z.object({ subscribed: z.boolean() });
export const ForumPollResponse = z.object({ poll: ForumPoll });
export const ForumEventRsvpResponse = z.object({ rsvp: ForumEventRsvpSummary });
export const ForumRevisionsResponse = z.object({
    revisions: z.array(ForumRevision),
});
export const ForumModerationActionsResponse = z.object({
    actions: z.array(z.object({
        id: z.string().uuid(),
        threadId: z.string().uuid(),
        postId: z.string().uuid().nullable(),
        action: z.string(),
        actorId: z.string().uuid().nullable(),
        reason: z.string().nullable(),
        meta: z.record(z.string(), z.unknown()),
        createdAt: z.string().datetime({ offset: true }),
    })),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
export const ForumVoteAuditResponse = z.object({
    votes: z.array(z.object({
        postId: z.string().uuid(),
        userId: z.string().uuid(),
        value: z.union([z.literal(-1), z.literal(1)]),
        createdAt: z.string().datetime({ offset: true }),
        updatedAt: z.string().datetime({ offset: true }),
    })),
});
export const ForumCapabilitiesResponse = z.object({
    forumEnabled: z.boolean(),
    votesEnabled: z.boolean(),
    acceptedAnswerEnabled: z.boolean(),
    subscriptionsEnabled: z.boolean(),
    domEditorReadonlyPreviewEnabled: z.boolean(),
    writableGroupIds: z.array(z.string().uuid()),
    moderatedGroupIds: z.array(z.string().uuid()),
    createKinds: z.array(ForumThreadKind),
});
//# sourceMappingURL=responses.js.map